import React from 'react';
import AdvertiserHeader from "./AdvertiserHeader";

const DefaultLayout = ({ children }) => {
  return (
    <div className="default-layout">
      <AdvertiserHeader/>
      <div className="default-layout-content">
        {children}
      </div>
    </div>
  );
};

export default DefaultLayout;
